import {useState, useEffect} from 'react';
import {useParams } from 'react-router-dom';
import InstaGrid from '../../components/InstaGrid/InstaGrid';
import "../../index.css";
import "./VideoGalleryPage.css";


function VideoGalleryPage({classification}) {
    
  
  let titlePhrase

  switch(classification){
      case "portrait":
      titlePhrase = "Video Portraits"
      break;
    case "commercial":
      titlePhrase = "Commercial Videos"
      break;
    case "cinematic":
      titlePhrase = "Cinematic Videos"
      break;
    default:
      titlePhrase = "Non-Descript Videos"
    
  }

  // const contentList = [
  //         { mediaType: "image", src: "/photo-assets/family/family-2.webp", alt: "Family protrait featuring a mom, dad, and a baby." },
  //         { mediaType: "image", src: "/photo-assets/p-models/model-8.webp", alt: "", href: "public/photo-assets/p-models/model-8.webp" },
  //         { mediaType: "video", src: "/video-assets/in-the-city-1.mp4", coverSrc: "/video-assets/grid-video-covers/in-the-city-cover.png" },
  //         { mediaType: "youtube", src: "https://www.youtube.com/embed/_KLQaBlnsWY?autoplay=1&mute=0&playsinline=1", coverSrc: "/video-assets/grid-video-covers/nightwav-youtube-cover.png" }
  //       ]

  // Mock data representing different types of Instagram posts
  const MOCK_POSTS = [
    { id: 1, type: 'image', src: '/photo-assets/p-models/tara-set-alpha-1.jpg', likes: '1.2k', comments: 84 },
    { id: 2, type: 'video', src: '/photo-assets/p-models/tara-set-alpha-2.jpg', likes: 543, comments: 22 },
    { id: 3, type: 'carousel', src: '/photo-assets/p-models/model-8.webp', likes: '3.4k', comments: 210 },
    { id: 4, type: 'image', src: '/photo-assets/p-models/tara-set-alpha-2.jpg', likes: 98, comments: 4 },
    { id: 5, type: 'video', src: '/photo-assets/p-models/tara-set-alpha-1.jpg', likes: '12.5k', comments: 843 },
    { id: 6, type: 'image', src: '/photo-assets/p-models/tara-set-alpha-2.jpg', likes: 231, comments: 15 },
  ];
  return (

    <div className="proto-page-container">
        {/* <div style={{height: "75vh"}} className='flex-column-centere '><h1 className='break-word clr-dark-red centered-text font-size-6'>Photography</h1></div> */}
        {/* <BlurryMedia src="/video-assets/midnight-eye.gif" alt="ad random image"/>
        <BlurryMedia src="/photo-assets/family/family-2.webp" alt="a random image"/> */}

        {/* <LetteredMedia title="Photography" src={heroVideo} video bgColor="bg-dark-blue" titleColor="clr-dark-red"/> */}
        
        <div className="top-page-title clr-dark-red" >{titlePhrase}</div>

        <div className="section-page-title clr-dark-blue" >{"category"}</div>
        <InstaGrid contentList={MOCK_POSTS} class_Name="insta-grid-styles"/>

        <div className="section-page-title clr-dark-blue" >{"category"}</div>
        <InstaGrid contentList={MOCK_POSTS} class_Name="insta-grid-styles"/>

        <div className="section-page-title clr-dark-blue" >{"category"}</div>
        <InstaGrid contentList={MOCK_POSTS} class_Name="insta-grid-styles"/>

    </div>
   
  );
}

export default VideoGalleryPage
;
